import React from 'react'
import { Provider } from 'react-redux'
import { styledTheme } from 'heliocor-ui'
import { I18nextProvider } from 'react-i18next';

import CAFe from './CAFe'
import i18n from './i18n';
import configureStore from './store/store'
import { GlobalStyle } from './styles/GlobalStyle'
import CustomThemeWrapper from './CustomThemeWrapper'

export const store = configureStore()

function App() {
    return (
        <>
            <GlobalStyle theme={styledTheme} />
            <I18nextProvider i18n={i18n}>
                <Provider store={store}>
                    <CustomThemeWrapper>
                        <CAFe />
                    </CustomThemeWrapper>
                </Provider>
            </I18nextProvider>
        </>
    )
}

export default App
